'use strict';

var bluebird = require('bluebird');
var _ = require('lodash');
var SystemStatusDemandReinitializationTransformerFactory = function SystemStatusDemandReinitializationTransformerFactory($rootScope, DataTransformer, momentService, UserProcessingTransformationService, reinitService) {
  var DEFAULT_FORECAST_TYPE = 'Market';
  function SystemStatusDemandReinitializationTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'system-status-demand-reinitialization-mode';
    this.priority = 1;
  }
  function formatYesNo(booleanValue) {
    return booleanValue ? 'Yes' : 'No';
  }
  SystemStatusDemandReinitializationTransformer.prototype = Object.create(DataTransformer.prototype);
  SystemStatusDemandReinitializationTransformer.constructor = SystemStatusDemandReinitializationTransformer;
  SystemStatusDemandReinitializationTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  SystemStatusDemandReinitializationTransformer.prototype.isCacheable = function () {
    return false;
  };
  SystemStatusDemandReinitializationTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  SystemStatusDemandReinitializationTransformer.prototype.transform = function (data) {
    return bluebird.join(bluebird.resolve(transformData(data && data.domain || [])), reinitService.getDirectForecastWorkloadPendingMarkets(), reinitService.getOlapLambdaRequestPendingMarkets(), reinitService.getDemandReinitializationOnProgressMarkets()).then(function (results) {
      var nonEditableMarketsDirectForecastWorkload = results[1];
      var nonEditableMarketsOlapRequest = results[2];
      var nonEditableMarketsDemandReinitialization = results[3];
      var entries = results[0];
      var nonEditableMarkets = nonEditableMarketsDemandReinitialization.concat(nonEditableMarketsOlapRequest).concat(nonEditableMarketsDirectForecastWorkload);
      for (var itemIndex in entries) {
        var entry = entries[itemIndex];
        entry.isMarketInPendingOlapQueue = _.includes(nonEditableMarkets, [entry.origin, entry.destination].join('-'));
      }
      return entries;
    });
  };
  function transformData(domain) {
    for (var itemIndex in domain) {
      var entry = domain[itemIndex];
      entry.isRowEditable = true;
      entry.isRowRemovable = false;
      entry.startDepartureDate = momentService.of(entry.startDepartureDate, momentService.FIELD.DEPARTURE_DATE);
      entry.endDepartureDate = momentService.of(entry.endDepartureDate, momentService.FIELD.DEPARTURE_DATE);
      entry.completionDate = momentService.of(entry.completionDate, momentService.FIELD.COMPLETED_DATE);
      entry.requestDate = momentService.of(entry.creationDate, momentService.FIELD.CREATED_DATE);
      entry.clearDemandAdjsFlag = formatYesNo(entry.clearDemandAdjsFlag);
      entry.forecastType = _.get(entry, 'forecastType', DEFAULT_FORECAST_TYPE) || DEFAULT_FORECAST_TYPE;
      if (entry.userName) {
        entry.userName = UserProcessingTransformationService.getUserDisplayName(entry.userName);
      }
      delete entry.creationDate;
    }
    return domain;
  }
  return SystemStatusDemandReinitializationTransformer;
};
SystemStatusDemandReinitializationTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory', 'MomentService', 'UserProcessingTransformationService', 'ReinitializationService'];
module.exports = SystemStatusDemandReinitializationTransformerFactory;